module.exports = __webpack_public_path__ + "img/mercedes-eqc-3.3195b76e.jpg";